<template>
  <div>
    <el-row :gutter="20">
      <el-col :span="3">
        <el-card class="list-selector">
          <ul class="list-selector-list">
            <li @click="swatchVipLevel({ levelName: '全部', vipLevelId: '' })"
              :class="{ 'selected': shopVipUserInfo.conditions.vipLevel === '' }">
              {{ $t('common.all') }}
            </li>
            <li v-for="(item, index) in shopVipUserInfo.vipLevels" :key="index"
              @click="swatchVipLevel(item)"
              :class="{ 'selected': shopVipUserInfo.conditions.vipLevel == item.vipLevelId }">
              {{ item.levelName }}
            </li>
          </ul>
        </el-card>
      </el-col>
      <el-col :span="21">
        <el-card>
          <div slot="header" class="clearfix flex justify-between">
            <span>查询条件</span>
          </div>
          <el-form :inline="true" class="demo-form-inline text-left">
            <el-form-item>
              <el-input v-model="shopVipUserInfo.conditions.vipName" placeholder="请输入会员名称" clearable
                style="width:200px" />
            </el-form-item>
            <el-form-item>
              <el-input v-model="shopVipUserInfo.conditions.vipTel" placeholder="请输入电话" clearable
                style="width:200px" />
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="_queryShopVipUserMethod">
                <i class="el-icon-search"></i> 查询
              </el-button>
              <el-button @click="_resetShopVipUserMethod">
                <i class="el-icon-refresh"></i> 重置
              </el-button>
            </el-form-item>
          </el-form>
        </el-card>

        <el-card style="margin-top: 20px;">
          <div slot="header" class="clearfix flex justify-between">
            <span>会员信息</span>
            <div>
              <el-button type="primary" size="small" @click="_openAddShopVipUserModal">
                <i class="el-icon-plus"></i>添加会员
              </el-button>
              <el-button type="primary" size="small" @click="_exportShopVipUser">
                导出
              </el-button>
            </div>
          </div>
          <el-table :data="shopVipUserInfo.shopVipUsers" border style="width:100%" v-loading="loading">
            <el-table-column prop="vipId" label="会员编号" align="center" />
            <el-table-column prop="vipName" label="会员名称" align="center" />
            <el-table-column prop="vipTel" label="会员电话" align="center" />
            <el-table-column prop="sex" label="性别" align="center">
              <template #default="{row}">
                {{ row.sex == '0' ? '女' : '男' }}
              </template>
            </el-table-column>
            <el-table-column prop="levelName" label="会员等级" align="center" />
            <el-table-column prop="birthday" label="会员生日" align="center" />
            <el-table-column prop="startTime" label="开始时间" align="center" />
            <el-table-column prop="endTime" label="结束时间" align="center" />
            <el-table-column label="操作" align="center" width="200">
              <template #default="{row}">
                <el-button size="mini" @click="_openEditShopVipUserModel(row)">
                  修改
                </el-button>
                <el-button size="mini" type="danger" @click="_openDeleteShopVipUserModel(row)">
                  删除
                </el-button>
                <el-button size="mini" @click="_toUserVipDetail(row)">
                  详情
                </el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination @current-change="handleCurrentChange" :current-page.sync="shopVipUserInfo.conditions.page"
            :page-size="shopVipUserInfo.conditions.row" layout="total, prev, pager, next"
            :total="shopVipUserInfo.total" style="margin-top: 20px; text-align: right;">
          </el-pagination>
        </el-card>
      </el-col>
    </el-row>

    <add-shop-vip-user ref="addShopVipUser" @refresh="listShopVipUsers()"/>
    <edit-shop-vip-user ref="editShopVipUser" @refresh="listShopVipUsers()"/>
    <delete-shop-vip-user ref="deleteShopVipUser" @refresh="listShopVipUsers()"/>
  </div>
</template>

<script>
import { getShopId } from '@/api/shop/shopApi'
import { queryShopVipUser, queryShopVipLevel, exportShopVipUser } from '@/api/user/shopVipUserApi'
import AddShopVipUser from '@/components/user/addShopVipUser/addShopVipUser'
import EditShopVipUser from '@/components/user/editShopVipUser/editShopVipUser'
import DeleteShopVipUser from '@/components/user/deleteShopVipUser/deleteShopVipUser'

export default {
  name: 'ShopVipUser',
  components: {
    AddShopVipUser,
    EditShopVipUser,
    DeleteShopVipUser
  },
  data() {
    return {
      loading: false,
      shopVipUserInfo: {
        shopVipUsers: [],
        total: 0,
        records: 1,
        moreCondition: false,
        vipId: '',
        vipLevels: [],
        conditions: {
          vipName: '',
          vipTel: '',
          vipLevel: '',
          shopId: '',
          page: 1,
          row: 10
        }
      }
    }
  },
  created() {
    this._listShopVipUsers()
    this._listShopVipLevels()
  },
  methods: {
    handleCurrentChange(val) {
      this.shopVipUserInfo.conditions.page = val
      this._listShopVipUsers()
    },
    async _listShopVipUsers() {
      this.loading = true
      this.shopVipUserInfo.conditions.shopId = getShopId()
      try {
        const res = await queryShopVipUser(this.shopVipUserInfo.conditions)
        this.shopVipUserInfo.total = res.total
        this.shopVipUserInfo.records = res.records
        this.shopVipUserInfo.shopVipUsers = res.data
      } catch (error) {
        console.error('获取会员列表失败:', error)
      } finally {
        this.loading = false
      }
    },
    _openAddShopVipUserModal() {
      this.$refs.addShopVipUser.open()
    },
    _openEditShopVipUserModel(shopVipUser) {
      this.$refs.editShopVipUser.open(shopVipUser)
    },
    _openDeleteShopVipUserModel(shopVipUser) {
      this.$refs.deleteShopVipUser.open(shopVipUser)
    },
    _queryShopVipUserMethod() {
      this.shopVipUserInfo.conditions.page = 1
      this._listShopVipUsers()
    },
    _resetShopVipUserMethod() {
      this.shopVipUserInfo.conditions = {
        vipName: '',
        vipTel: '',
        vipLevel: '',
        shopId: '',
        page: 1,
        row: 10
      }
      this._listShopVipUsers()
    },
    async _listShopVipLevels() {
      const params = {
        page: 1,
        row: 50,
        shopId: getShopId()
      }
      try {
        const res = await queryShopVipLevel(params)
        this.shopVipUserInfo.vipLevels = res.data
      } catch (error) {
        console.error('获取会员等级失败:', error)
      }
    },
    _toUserVipDetail(shopVipUser) {
      window.open('/#/pages/user/vipDetail?vipId=' + shopVipUser.vipId)
    },
    swatchVipLevel(shopVipUser) {
      this.shopVipUserInfo.conditions.vipLevel = shopVipUser.vipLevelId
      this._listShopVipUsers()
    },
    async _exportShopVipUser() {
      this.shopVipUserInfo.conditions.pagePath = 'shopVipUser'
      try {
        const res = await exportShopVipUser(this.shopVipUserInfo.conditions)
        this.$message.success(res.msg)
        if (res.code === 0) {
          this.$router.push('/pages/property/downloadTempFile?tab=下载中心&fileType=shopVipUser')
        }
      } catch (error) {
        console.error('导出失败:', error)
      }
    }
  }
}
</script>

<style scoped>
/* 使用 el-card 和全局 list-selector 样式，无需自定义样式 */
</style>